import React, { useState, useEffect } from 'react';
import { CardActionable } from '@americanexpress/dls-react';
import { IconCheck } from '@americanexpress/dls-icons';
import PropTypes from 'prop-types';

/**
 * Card Selection component return custom component
 * @param {*} param
 */
const CardSelection = ({
  fieldId,
  isMultiSelect,
  selectionOptions,
  handleOnChangeEvents,
  onElementChange = [],
}) => {
  const [isOptionSelected, setIsOptionSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState([]);
  let optionValues;
  useEffect(() => {
    optionValues = selectedOption.map((option) => option.value);
    // console.log("array", optionValues);
    const final = JSON.stringify(optionValues);
    // console.log("FInal ", final);
    handleOnChangeEvents(onElementChange, '', final);
  }, [selectedOption]);

  const handleCardSelection = (option) => {
    setIsOptionSelected(true);
    const selectedIndex = selectedOption.findIndex((opt) => opt.optionId === option.optionId);

    if (isMultiSelect && selectedIndex > -1) {
      const allOptions = [...selectedOption];
      allOptions.splice(selectedIndex, 1);
      setSelectedOption([...allOptions]);
    } else {
      const options = isMultiSelect ? [...selectedOption, option] : [{ ...option }];
      setSelectedOption([...options]);
    }
  };

  return (
    <div className="row pad-responsive" id={fieldId}>
      {
        selectionOptions && selectionOptions.length > 0 && selectionOptions.map((option) => (
          <CardActionable
            className="col-lg-12 col-xs-12 margin-responsive-b"
            onClick={() => handleCardSelection(option)}
            key={option.optionId}
          >
            <div className="flex width-full">
              <div>
                <p className="body-1 dls-gray-06">
                  {option.value}
                </p>
              </div>
              {
                isOptionSelected
                && selectedOption.findIndex((opt) => opt.optionId === option.optionId) > -1
                && (
                  <div className="pad-responsive-r margin-auto-l">
                    <IconCheck
                      className="dls-bright-blue"
                      size="md"
                    />
                  </div>
                )
              }
            </div>
          </CardActionable>
        ))
      }
    </div>
  );
};

CardSelection.propTypes = {
  fieldId: PropTypes.string,
  isMultiSelect: PropTypes.bool,
  selectionOptions: PropTypes.objectOf(PropTypes.shape),
  onElementChange: PropTypes.arrayOf(PropTypes.shape),
  handleOnChangeEvents: PropTypes.func,
};

export default CardSelection;
